import { useEffect, useMemo, useState } from "react";
import "./CategoryFormModal.css";

function SubcategoryFormModal({
  isOpen,
  onClose,
  categoria,
  subcategoriaData,
  onSubmit,
}) {
  const isEdit = !!subcategoriaData;

  const initialForm = useMemo(
    () => ({
      nombre: subcategoriaData?.nombre || "",
      estado:
        subcategoriaData?.estado !== undefined && subcategoriaData?.estado !== null
          ? Number(subcategoriaData.estado)
          : 1,
    }),
    [subcategoriaData]
  );

  const [form, setForm] = useState(initialForm);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!isOpen) return;
    setForm(initialForm);
    setSaving(false);
    setError("");
  }, [isOpen, initialForm]);

  useEffect(() => {
    if (!isOpen) return;
    const onEsc = (e) => {
      if (e.key === "Escape" && !saving) onClose?.();
    };
    window.addEventListener("keydown", onEsc);
    return () => window.removeEventListener("keydown", onEsc);
  }, [isOpen, onClose, saving]);

  if (!isOpen || !categoria) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const nombre = String(form.nombre || "").trim();
    if (!nombre) {
      setError("El nombre es obligatorio.");
      return;
    }

    setError("");
    setSaving(true);
    try {
      await onSubmit({
        nombre,
        categoria_producto_id: Number(categoria.categoria_producto_id),
        estado: Number(form.estado),
      });
      onClose?.();
    } catch (err) {
      setError(err?.message || "No se pudo guardar la subcategoría.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      className="tienda-modal__overlay"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget && !saving) onClose?.();
      }}
    >
      <div className="tienda-modal tienda-modal--shell" onMouseDown={(e) => e.stopPropagation()}>
        <div className="tienda-modal__header">
          <div className="tienda-modal__header-text">
            <h2 className="tienda-modal__title">
              {isEdit ? "Editar subcategoría" : "Nueva subcategoría"}
            </h2>
            <p className="tienda-modal__subtitle">
              Categoría: <strong>{categoria.nombre}</strong>
            </p>
          </div>
          <button
            type="button"
            className="tienda-modal__close"
            onClick={onClose}
            disabled={saving}
            aria-label="Cerrar"
          >
            ×
          </button>
        </div>

        <form className="tienda-modal__body" onSubmit={handleSubmit}>
          {error ? <div className="tienda-modal__alert tienda-modal__alert--error">{error}</div> : null}

          <div className="tienda-modal__field">
            <label className="tienda-modal__label">Nombre</label>
            <input
              type="text"
              name="nombre"
              className="tienda-modal__input"
              placeholder="Ej. Filtros de aceite"
              maxLength={100}
              value={form.nombre}
              onChange={(e) => setForm((prev) => ({ ...prev, nombre: e.target.value }))}
              disabled={saving}
              autoFocus
            />
          </div>

          <div className="tienda-modal__field">
            <label className="tienda-modal__label">Estado</label>
            <select
              name="estado"
              className="tienda-modal__select"
              value={form.estado}
              onChange={(e) =>
                setForm((prev) => ({ ...prev, estado: Number(e.target.value) }))
              }
              disabled={saving}
            >
              <option value={1}>Activo</option>
              <option value={0}>Inactivo</option>
            </select>
          </div>

          <div className="tienda-modal__footer">
            <button
              type="button"
              className="tienda-modal__btn tienda-modal__btn--secondary"
              onClick={onClose}
              disabled={saving}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="tienda-modal__btn tienda-modal__btn--primary"
              disabled={saving}
            >
              {saving ? "Guardando..." : isEdit ? "Guardar cambios" : "Crear subcategoría"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default SubcategoryFormModal;
